import styled from 'styled-components';
import IconButton from '../../icon-button';
export var InputBoxWithCrossButton = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__InputBoxWithCrossButton",
  componentId: "sc-18dorj2-0"
})(["position:relative;"]);
export var CrossButton = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "style__CrossButton",
  componentId: "sc-18dorj2-1"
})(["position:absolute;right:0;top:14px;"]);